
<div [class]="'sidepanel-wrapper'" [ngClass]="{ active: displaySidePanel }">
  <div class="sidepanel-close" (click)="closeSidePanel()"></div>
  <div class="panel-content">
    <button class="panel-close-button" mat-icon-button aria-label="Close Panel" 
    (click)="closeSidePanel()">
      <mat-icon style="color: #0f0fd1;">close</mat-icon>
    </button>
    <div class="panel-top">
      <div>
        <h2 class="panel-title">Notifications</h2>
        <div style="display: flex;">
          <div class="panel-date">{{currentDate}}</div>
          <div class="panel-date">{{AM_PM}}</div>
        </div>
      </div>
      <div>
        <button [matMenuTriggerFor]="searchMenu" mat-icon-button type="button" matTooltip="Search">
          <mat-icon  style="color: #ffffff; margin-right: 3px;">search</mat-icon>
        </button>
        <button [matMenuTriggerFor]="filterMenu" mat-icon-button type="button" matTooltip="Filter Notifications">
          <mat-icon  style="color: #ffffff; margin-right: 3px;">filter_list</mat-icon>
        </button>
        <button [matMenuTriggerFor]="settingsMenu" mat-icon-button type="button" matTooltip="Settings">
          <mat-icon  style="color: #ffffff; margin-right: 3px;">settings</mat-icon>
        </button>
        <button mat-icon-button type="button" matTooltip="Refresh" (click)="refreshNotification()">
          <mat-icon style="color: #ffffff;">refresh</mat-icon>
        </button>
      </div>
    </div>
    <div class="panel-body">
      <p *ngIf="messages?.length === 0">Notifications will be shown here</p>
      <div class="notifications_card_wrapper" *ngIf="messages?.length > 0">
        <div class="notification_card" [style]="!message?.isRead ? 'background-color: #d2caca;' : 'background-color: #ffffff;'" 
        *ngFor="let message of messages;">
          <button *ngIf="!message?.isRead" class="clear_button" mat-icon-button type="button"
           (click)="markAsRead(message)" matTooltip="Mark as Read">
            <mat-icon>mark_chat_read</mat-icon>
          </button>
          <h3 [matTooltip]="message?.title" (click)="goToView(message)">{{message?.title}}</h3>
          <a *ngIf="shouldShowExportDownloadLink(message)" [href]="blobStorageUrl + message.elementId" target="_blank" rel="noopener noreferrer" style="color:rgb(11, 11, 242); text-decoration: underline;" download>Download File</a>
          <a *ngIf="message?.description === 'Export Notification' && !shouldShowExportDownloadLink(message)" href="/Home/Export" style="color:rgb(11, 11, 242);">Product Export</a>
          <p (click)="goToView(message)"
             [matTooltip]="isAdminAccessRequest(message) ? '' : message?.description"
             [class.full-text]="isAdminAccessRequest(message)">{{message?.description}}</p>

          <app-admin-access-notification-actions
            *ngIf="isAdminAccessRequest(message)"
            [message]="message"
            (actionDone)="onAdminAccessActionDone($event)">
          </app-admin-access-notification-actions>

          <p class="text-xs text-green-600 leading-none">{{message?.createdAt}}
          </p>
        </div>
        <div class="load_more_notifications" *ngIf="currentDataLength >= 10">
          <div (click)="onScroll()">
            <p>Load More</p>
            <mat-icon>download_for_offline</mat-icon>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>


  <mat-menu #settingsMenu="matMenu" xPosition="before" yPosition="below">
    <button mat-menu-item type="button" (click)="markAllAsRead()">
      <mat-icon>clear_all</mat-icon>
      <span>Mark all as read</span>
    </button>
    <button mat-menu-item type="button" (click)="onClearFilterClicked()">
      <mat-icon>remove</mat-icon>
      <span>Clear Filters</span>
    </button>  
    <button mat-menu-item type="button">
      <mat-icon>notifications_off</mat-icon>
      <span>Disable Notifications</span>
    </button>
    <button mat-menu-item type="button" (click)="deleteAll()">
      <mat-icon>delete_outline</mat-icon>
      <span>Clear all</span>
    </button>
  </mat-menu>
  <mat-menu xPosition="before" yPosition="below" #filterMenu="matMenu">
    <mat-checkbox 
    (click)="$event.stopPropagation();"
    class="option"
    color="primary"
    *ngFor="let type of types"
    [checked]="currentNotificationFilter.includes(type.key)"
    (change)="onChangeType($event, type.key)">{{type.value}}</mat-checkbox>
  </mat-menu>
  <mat-menu xPosition="before" yPosition="below" #searchMenu="matMenu">
    <div class="content-top-row w-custom" (click)="$event.stopPropagation();">
      <mat-form-field class="top-row-first-filed-item top-row-first-filed-item-order-processing w-100">
        <input matInput type="search" placeholder="Search..." 
        [formControl]="searchCtrl">
      </mat-form-field>
    </div>
  </mat-menu>